import { NodeProps } from '@xyflow/react';
import BaseNode from './baseNode';
import { UserAppNodeType } from './nodesUtils';

const UserAppNode = (node: NodeProps<UserAppNodeType>) => {
  return (
    <BaseNode
      node={node}
      icon={node.data.entity?.userAppDef?.instanceIcon || 'mobile-button'}
      label={node.data.entity?.userAppDef?.name || node.data.entity?.name || 'App'}
      canDelete={true}
    />
  );
};

export default UserAppNode;
